import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from "@k3-tech/react-kit";
import { GroupProductAddonList } from "./GroupProductAddonList";

export interface GroupProductAddonDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	productName: string;
	addonGroupID?: string | null;
	addonGroupName?: string | null;
}

export function GroupProductAddonDialog({
	open,
	onOpenChange,
	productName,
	addonGroupID,
	addonGroupName,
}: GroupProductAddonDialogProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-lg">
				<DialogHeader>
					<DialogTitle>{`Add-ons · ${productName}`}</DialogTitle>
				</DialogHeader>
				<div className="space-y-1">
					<div className="text-xs uppercase tracking-wide text-slate-400">
						Addon Group
					</div>
					<div className="font-medium">{addonGroupName || "-"}</div>
				</div>
				<div className="mt-2">
					<GroupProductAddonList
						addonGroupID={open ? addonGroupID : undefined}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
}
